module.exports = __webpack_public_path__ + "img/0030.90fea534.jpg";